import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import { VyLayout } from '../../../components/new-design/layout/VyLayout';
import { withGlobalSearchParams } from '../../../components/utility/GlobalSearchParamsBoundary';
import { withSuspenseBoundary } from '../../../components/utility/SuspenseBoundary';
import { FailedInvoiceDeliveriesReportContent } from './FailedInvoiceDeliveriesReportContent';

const FailedInvoiceDeliveriesReportPage: React.FC = () => {
  const { reportId } = useParams();

  return (
    <>
      <Helmet>
        <title>Report</title>
      </Helmet>
      <VyLayout>
        <FailedInvoiceDeliveriesReportContent reportId={reportId} />
      </VyLayout>
    </>
  );
};

const FailedInvoiceDeliveriesReportPageWithSuspenseBoundary = withSuspenseBoundary(
  withGlobalSearchParams(FailedInvoiceDeliveriesReportPage),
);

export { FailedInvoiceDeliveriesReportPageWithSuspenseBoundary as FailedInvoiceDeliveriesReportPage };
